var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .menu_a {\n                fill: #fff;\n            }\n\n            .menu_b {\n                fill: none !important;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "menu_a",
    d: "M9,15a3,3,0,1,0,3,3A3.011,3.011,0,0,0,9,15Zm18.012,0a3,3,0,1,0,3,3A3.011,3.011,0,0,0,27.014,15Zm-9.006,0a3,3,0,1,0,3,3A3.011,3.011,0,0,0,18.008,15Z",
    transform: "translate(-2 -2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "menu_b",
    width: 32,
    height: 32
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_menu.a3d5af1a12265d6a3014cc5b34157be3.svg";